import { useSelector } from 'react-redux';

import { currentOpenChatSelector, isShowSubAgentChatListSelector, userIdSelector } from '../../../selectors';
import { TMessage } from '../../../types/messages';

export enum EUserColor {
  Initial = 'initial',
  Dark = 'dark',
  Purple = 'purple',
  Plum = 'plum',
}

export const useUserColor = ({ userId: messageUserId }: TMessage): EUserColor => {
  const userId = useSelector(userIdSelector);
  const { users = [] } = useSelector(currentOpenChatSelector) || {};
  const isShowSubAgentChatList = useSelector(isShowSubAgentChatListSelector);

  const currentUser = users.find(user => user.userId === userId);
  const messageUser = users.find(user => user.userId === messageUserId);

  const hasCompanion = users.some(user => user.chatRole === 'companion');

  // Я - компаньон. Чужие имена - чёрные, мое имя - всегда черное
  if (currentUser?.chatRole === 'companion' || messageUser?.chatRole === 'companion') {
    return EUserColor.Dark;
  }

  // Я - инициатор. Компаньон - чёрный.
  // Оппонент и мастер - сливовые, если есть компаньон
  if (currentUser?.chatRole === 'initiator') {
    if (messageUser?.chatRole === 'master' && hasCompanion) {
      return EUserColor.Plum;
    }

    if (messageUser?.chatRole === 'opponent' && hasCompanion) {
      return EUserColor.Plum;
    }

    return EUserColor.Initial;
  }

  // Я - мастер (участник или смотрю чат субагента). Компаньон - чёрный, оппонент - пурпурный.
  // Инициатор сливовый, если есть компаньон.
  if (currentUser?.chatRole === 'master' || isShowSubAgentChatList) {
    if (messageUser?.chatRole === 'opponent') {
      return EUserColor.Purple;
    }

    if (messageUser?.chatRole === 'initiator' && hasCompanion) {
      return EUserColor.Plum;
    }
  }

  // Я - оппонент. Компаньон - чёрный, мастер - пурпурный.
  // Инициатор сливовый, если есть компаньон.
  if (currentUser?.chatRole === 'opponent') {
    if (messageUser?.chatRole === 'master') {
      return EUserColor.Purple;
    }

    if (messageUser?.chatRole === 'initiator' && hasCompanion) {
      return EUserColor.Plum;
    }
  }

  return EUserColor.Initial;
};
